import { LANGUAGE_TRACKING_EVENTS, TLanguageUpdate } from './index';
import { trackByEvent } from '../../tracking/services';
import { TRACKING_DEFAULTS } from '../../tracking/constant';

const trackLanguageUpdate = (languageString: string) => {
  try {
    trackByEvent<TLanguageUpdate>(
      LANGUAGE_TRACKING_EVENTS.LANGUAGE_UPDATE.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        component_type: 'dialog',
        component_name: LANGUAGE_TRACKING_EVENTS.LANGUAGE_UPDATE.component_name,
        country: '',
        language: languageString || '',
        dialog_action: LANGUAGE_TRACKING_EVENTS.LANGUAGE_UPDATE.action,
      }
    );
  } catch (error) {
    console.log('trackLanguageUpdate error', error);
  }
};

export { trackLanguageUpdate };
